export const academyMock = {
  summary: {
    totalCourses: 6,
    activeStudents: 1240,
    completedLessons: 8420,
    issuedCertificates: 352,
    lockedRewardsIssued: '48,240 $NEURONS mock',
    unlockedRewardsIssued: '7,100 $NEURONS mock',
    tutorsPendingValidation: 3,
    constitutionalStanding: 'approved',
    pokReadiness: 72,
    trustScore: 78,
  },
  student: {
    id: 'mock-user-001',
    name: 'Academy Contributor',
    level: 'Governance Apprentice',
    levelIndex: 4,
    trustScore: 78,
    constitutionalStanding: 'approved',
    pokReadiness: 72,
    completedCourses: 3,
    activeCourses: 2,
    certifications: 2,
    lockedNeurons: 1840,
    unlockedNeurons: 420,
    acsEligibility: 'eligible-for-review',
    marketplaceEligibility: 'eligible-for-vouchers',
    daoAffiliation: 'Root DAO',
    organizationHierarchy: 'Axodus Root DAO / Academy Contributor Track',
    federationStatus: 'federation-compatible',
  },
  futureContracts: [
    { id: 'pok-minter', name: 'PoKMinter', role: 'Future controlled issuer for PoK-approved $NEURONS rewards.', status: 'mock-read-model', writesEnabled: false },
    { id: 'locked-neurons-vault', name: 'LockedNeuronsVault', role: 'Future vault for internal, non-transferable Locked $NEURONS balances.', status: 'mock-read-model', writesEnabled: false },
    { id: 'reward-policy', name: 'RewardPolicy', role: 'Future governance policy surface for reward classes, unlock rules, and anti-abuse limits.', status: 'mock-read-model', writesEnabled: false },
    { id: 'treasury-emission-budget', name: 'TreasuryEmissionBudget', role: 'Future treasury budget envelope for approved Academy emissions.', status: 'mock-read-model', writesEnabled: false },
  ],
  tutors: [
    { id: 'academy-tutor-001', name: 'Axodus Governance Faculty', type: 'Internal Axodus Educator', verificationStatus: 'verified', governanceStanding: 'verified', reputation: 96, coursesPublished: 4, certificatesIssued: 128, educationalTier: 'Constitutional', constitutionalBound: true, rewardEligible: true, description: 'Internal faculty responsible for constitutional literacy, DAO operations, and treasury-aware learning paths.' },
    { id: 'academy-tutor-002', name: 'Treasury Risk Guild', type: 'DAO', verificationStatus: 'under-review', governanceStanding: 'probation', reputation: 84, coursesPublished: 2, certificatesIssued: 42, educationalTier: 'Professional', constitutionalBound: true, rewardEligible: true, description: 'DAO tutor group preparing operators for treasury, risk, and protocol participation.' },
    { id: 'academy-tutor-003', name: 'Marketplace Ops Guild', type: 'Partner', verificationStatus: 'verified', governanceStanding: 'verified', reputation: 89, coursesPublished: 3, certificatesIssued: 77, educationalTier: 'Ecosystem', constitutionalBound: true, rewardEligible: true, description: 'Partner educator focused on creator monetization, voucher usage, and educational commerce.' },
    { id: 'academy-tutor-004', name: 'ACS Integrity Desk', type: 'Governance Educator', verificationStatus: 'verified', governanceStanding: 'verified', reputation: 92, coursesPublished: 2, certificatesIssued: 61, educationalTier: 'Integrity', constitutionalBound: true, rewardEligible: true, description: 'ACS education team focused on moderation, plagiarism controls, reward abuse detection, and PoK review readiness.' },
    { id: 'academy-tutor-005', name: 'Partner Growth Cohort', type: 'Partner', verificationStatus: 'under-review', governanceStanding: 'restricted', reputation: 71, coursesPublished: 1, certificatesIssued: 8, educationalTier: 'Ecosystem Candidate', constitutionalBound: true, rewardEligible: false, description: 'Partner cohort in restricted review while tutor monetization, revenue-share, and moderation controls are validated.' },
  ],
  courses: [
    {
      id: 'academy-course-001',
      title: 'Axodus Constitutional Onboarding',
      slug: 'constitutional-onboarding',
      category: 'Governance',
      subcategory: 'Constitution',
      level: 'Introductory',
      type: 'Free Course',
      accessType: 'free',
      price: '0',
      tutorId: 'academy-tutor-001',
      description: 'The required formation path for understanding Axodus constitutional standards, ecosystem roles, and responsible participation.',
      shortDescription: 'Constitutional literacy for new Axodus participants.',
      thumbnail: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&w=900&q=80',
      banner: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&w=1600&q=80',
      tags: ['constitution', 'governance', 'onboarding'],
      language: 'English',
      estimatedDuration: '3h 20m',
      durationMinutes: 200,
      lessonsCount: 6,
      status: 'published',
      governanceStatus: 'approved',
      constitutionalStanding: 'compliant',
      certificateEnabled: true,
      proofOfKnowledgeRequired: true,
      rewardType: 'Locked $NEURONS',
      rewardAmount: 320,
      rewardLocked: true,
      rewardSource: 'Free Course',
      rewardUtility: ['vouchers', 'NFT access', 'marketplace purchases', 'internal services', 'voting utilities'],
      transferabilityStatus: 'internal-only',
      certificationOutcome: 'Foundational constitutional literacy',
      governanceUnlocks: ['introductory voting utility', 'governance orientation completed'],
      daoRecognition: 'Axodus Root DAO recognized',
      treasurySponsor: 'TreasuryEmissionBudget onboarding envelope',
      operationalValue: 'Required onboarding for responsible ecosystem participation.',
      prerequisites: [],
      supportedChains: ['EVM', 'Solana'],
      nftAccessRequired: false,
      acceptedCurrencies: [],
      progress: 82,
    },
    {
      id: 'academy-course-002',
      title: 'Treasury Risk and Sustainable Emissions',
      slug: 'treasury-risk-sustainable-emissions',
      category: 'Treasury',
      subcategory: 'Risk',
      level: 'Advanced',
      type: 'Paid Course',
      accessType: 'paid',
      price: '149 USDC mock',
      tutorId: 'academy-tutor-002',
      description: 'Professional track covering emission budgets, reward abuse prevention, treasury reporting, and governance-controlled distribution.',
      shortDescription: 'Treasury-aware reward design for protocol operators.',
      thumbnail: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=900&q=80',
      banner: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=1600&q=80',
      tags: ['treasury', 'risk', 'rewards'],
      language: 'English',
      estimatedDuration: '6h 45m',
      durationMinutes: 405,
      lessonsCount: 10,
      status: 'published',
      governanceStatus: 'under-review',
      constitutionalStanding: 'under-review',
      certificateEnabled: true,
      proofOfKnowledgeRequired: true,
      rewardType: 'Unlocked $NEURONS',
      rewardAmount: 950,
      rewardLocked: false,
      rewardSource: 'Paid Course',
      rewardUtility: ['future wallet distribution', 'professional certification', 'governance eligibility'],
      transferabilityStatus: 'future-wallet-transfer',
      certificationOutcome: 'Professional treasury emissions operator',
      governanceUnlocks: ['treasury review literacy', 'emission policy review readiness'],
      daoRecognition: 'Treasury Council review pending',
      treasurySponsor: 'TreasuryEmissionBudget professional education envelope',
      operationalValue: 'Prepares operators to reason about sustainable reward issuance.',
      prerequisites: ['academy-course-001'],
      supportedChains: ['EVM'],
      nftAccessRequired: false,
      acceptedCurrencies: ['USDC', '$NEURONS'],
      progress: 46,
    },
    {
      id: 'academy-course-003',
      title: 'Marketplace Activation and Tutor Monetization',
      slug: 'marketplace-activation-tutor-monetization',
      category: 'Marketplace',
      subcategory: 'Creator Economy',
      level: 'Intermediate',
      type: 'Free Course',
      accessType: 'free',
      price: '0',
      tutorId: 'academy-tutor-003',
      description: 'Learn how education, vouchers, NFTs, creator royalties, and internal services compose into Academy marketplace activation.',
      shortDescription: 'Marketplace literacy for students, tutors, and ecosystem creators.',
      thumbnail: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=900&q=80',
      banner: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=1600&q=80',
      tags: ['marketplace', 'tutors', 'vouchers'],
      language: 'Portuguese',
      estimatedDuration: '4h 10m',
      durationMinutes: 250,
      lessonsCount: 8,
      status: 'published',
      governanceStatus: 'approved',
      constitutionalStanding: 'approved',
      certificateEnabled: true,
      proofOfKnowledgeRequired: true,
      rewardType: 'Locked $NEURONS',
      rewardAmount: 410,
      rewardLocked: true,
      rewardSource: 'Free Course',
      rewardUtility: ['marketplace purchases', 'educational NFTs', 'licenses', 'internal benefits'],
      transferabilityStatus: 'internal-only',
      certificationOutcome: 'Marketplace activation credential',
      governanceUnlocks: ['voucher utility eligibility', 'creator onboarding recognized'],
      daoRecognition: 'Marketplace Ops Guild recognized',
      treasurySponsor: 'TreasuryEmissionBudget marketplace activation envelope',
      operationalValue: 'Connects learning progression to marketplace utility and tutor monetization.',
      prerequisites: ['academy-course-001'],
      supportedChains: ['EVM', 'Solana'],
      nftAccessRequired: false,
      acceptedCurrencies: [],
      progress: 100,
    },
    {
      id: 'academy-course-004',
      title: 'Proof of Knowledge Certification Design',
      slug: 'proof-of-knowledge-certification-design',
      category: 'Proof of Knowledge',
      subcategory: 'Certification',
      level: 'Advanced',
      type: 'Paid Course',
      accessType: 'paid',
      price: '199 USDC mock',
      tutorId: 'academy-tutor-001',
      description: 'Design PoK checkpoints, anti-fraud certification flows, and future credential compatibility without issuing real credentials.',
      shortDescription: 'PoK validation architecture for Academy certification stewards.',
      thumbnail: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=900&q=80',
      banner: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1600&q=80',
      tags: ['PoK', 'certification', 'anti-abuse'],
      language: 'English',
      estimatedDuration: '7h 30m',
      durationMinutes: 450,
      lessonsCount: 12,
      status: 'draft-preview',
      governanceStatus: 'under-review',
      constitutionalStanding: 'under-review',
      certificateEnabled: true,
      proofOfKnowledgeRequired: true,
      rewardType: 'Unlocked $NEURONS',
      rewardAmount: 1200,
      rewardLocked: false,
      rewardSource: 'Paid Course',
      rewardUtility: ['future wallet distribution', 'certification authority', 'ACS review eligibility'],
      transferabilityStatus: 'future-wallet-transfer',
      certificationOutcome: 'PoK certification steward preview',
      governanceUnlocks: ['ACS reviewer threshold', 'credential integrity review readiness'],
      daoRecognition: 'ACS Certification Queue pending',
      treasurySponsor: 'TreasuryEmissionBudget advanced credential envelope',
      operationalValue: 'Prepares future stewards for credential integrity and anti-fraud reviews.',
      prerequisites: ['academy-course-001', 'academy-course-002'],
      supportedChains: ['EVM'],
      nftAccessRequired: true,
      acceptedCurrencies: ['USDC', '$NEURONS'],
      progress: 18,
    },
    {
      id: 'academy-course-005',
      title: 'ACS Moderation and Reward Abuse Review',
      slug: 'acs-moderation-reward-abuse-review',
      category: 'ACS',
      subcategory: 'Integrity',
      level: 'Intermediate',
      type: 'Free Course',
      accessType: 'free',
      price: '0',
      tutorId: 'academy-tutor-004',
      description: 'Structured formation for identifying abuse patterns, fake completion signals, plagiarism risks, and reward escalation boundaries.',
      shortDescription: 'ACS readiness for moderation and reward abuse review.',
      thumbnail: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=900&q=80',
      banner: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1600&q=80',
      tags: ['ACS', 'moderation', 'anti-abuse'],
      language: 'English',
      estimatedDuration: '5h 05m',
      durationMinutes: 305,
      lessonsCount: 9,
      status: 'published',
      governanceStatus: 'approved',
      constitutionalStanding: 'approved',
      certificateEnabled: true,
      proofOfKnowledgeRequired: true,
      rewardType: 'Locked $NEURONS',
      rewardAmount: 520,
      rewardLocked: true,
      rewardSource: 'Free Course',
      rewardUtility: ['ACS queue access', 'internal services', 'review vouchers', 'voting utilities'],
      transferabilityStatus: 'internal-only',
      certificationOutcome: 'ACS moderation readiness',
      governanceUnlocks: ['ACS review queue preview', 'reward audit literacy'],
      daoRecognition: 'ACS Integrity Desk recognized',
      treasurySponsor: 'TreasuryEmissionBudget integrity education envelope',
      operationalValue: 'Prepares contributors to recognize manipulation risks before reward or credential escalation.',
      prerequisites: ['academy-course-001'],
      supportedChains: ['EVM'],
      nftAccessRequired: false,
      acceptedCurrencies: [],
      progress: 64,
    },
    {
      id: 'academy-course-006',
      title: 'DAO Tutor Monetization and Royalty Controls',
      slug: 'dao-tutor-monetization-royalty-controls',
      category: 'Marketplace',
      subcategory: 'Tutor Economy',
      level: 'Advanced',
      type: 'Paid Course',
      accessType: 'paid',
      price: '129 USDC mock',
      tutorId: 'academy-tutor-005',
      description: 'Premium program for tutor monetization, marketplace licensing, DAO sponsorship, royalty models, and restricted partner onboarding controls.',
      shortDescription: 'Tutor monetization and DAO-aligned royalty controls.',
      thumbnail: 'https://images.unsplash.com/photo-1559136555-9303baea8ebd?auto=format&fit=crop&w=900&q=80',
      banner: 'https://images.unsplash.com/photo-1559136555-9303baea8ebd?auto=format&fit=crop&w=1600&q=80',
      tags: ['tutors', 'royalties', 'marketplace'],
      language: 'Portuguese',
      estimatedDuration: '6h 15m',
      durationMinutes: 375,
      lessonsCount: 11,
      status: 'draft-preview',
      governanceStatus: 'restricted',
      constitutionalStanding: 'restricted',
      certificateEnabled: true,
      proofOfKnowledgeRequired: true,
      rewardType: 'Unlocked $NEURONS',
      rewardAmount: 780,
      rewardLocked: false,
      rewardSource: 'Paid Course',
      rewardUtility: ['future wallet distribution', 'tutor monetization credential', 'marketplace publisher eligibility'],
      transferabilityStatus: 'future-wallet-transfer',
      certificationOutcome: 'Tutor monetization steward preview',
      governanceUnlocks: ['publisher eligibility review', 'royalty policy literacy'],
      daoRecognition: 'Partner DAO review restricted',
      treasurySponsor: 'TreasuryEmissionBudget partner education envelope',
      operationalValue: 'Clarifies tutor monetization and royalty policy before marketplace execution.',
      prerequisites: ['academy-course-001', 'academy-course-003'],
      supportedChains: ['EVM', 'Solana'],
      nftAccessRequired: true,
      acceptedCurrencies: ['USDC', '$NEURONS'],
      progress: 0,
    },
  ],
  lessons: [
    { id: 'lesson-001', courseId: 'academy-course-001', title: 'Academy as Constitutional Infrastructure', type: 'Reading', order: 1, duration: '28m', completionRequired: true, quizRequired: false, media: 'article', resources: ['Academy Constitution'], status: 'available' },
    { id: 'lesson-002', courseId: 'academy-course-001', title: 'Governance Literacy and Voting Utility', type: 'Governance Review', order: 2, duration: '35m', completionRequired: true, quizRequired: true, media: 'workshop', resources: ['Governance primer'], status: 'available' },
    { id: 'lesson-003', courseId: 'academy-course-002', title: 'Emission Budgets and Treasury Boundaries', type: 'Workshop', order: 1, duration: '44m', completionRequired: true, quizRequired: true, media: 'video', resources: ['Treasury model'], status: 'available' },
    { id: 'lesson-004', courseId: 'academy-course-003', title: 'Locked $NEURONS Utility in Marketplace Flows', type: 'Practical Exercise', order: 1, duration: '39m', completionRequired: true, quizRequired: true, media: 'exercise', resources: ['Voucher map'], status: 'completed' },
    { id: 'lesson-005', courseId: 'academy-course-004', title: 'PoK Evidence, Proof Hashes, and Review Boundaries', type: 'Quiz', order: 1, duration: '31m', completionRequired: true, quizRequired: true, media: 'quiz', resources: ['PoK checklist'], status: 'locked' },
    { id: 'lesson-006', courseId: 'academy-course-005', title: 'ACS Abuse Signals and Escalation Rules', type: 'Governance Review', order: 1, duration: '42m', completionRequired: true, quizRequired: true, media: 'workshop', resources: ['ACS escalation matrix'], status: 'available' },
    { id: 'lesson-007', courseId: 'academy-course-006', title: 'Royalty Controls and Partner Restrictions', type: 'Reading', order: 1, duration: '37m', completionRequired: true, quizRequired: true, media: 'article', resources: ['Marketplace royalty policy'], status: 'locked' },
  ],
  learningProgress: [
    { userId: 'mock-user-001', courseId: 'academy-course-001', progress: 82, completedLessons: 5, pendingLessons: 1, certificateStatus: 'pending', rewardStatus: 'locked-pending-completion' },
    { userId: 'mock-user-001', courseId: 'academy-course-002', progress: 46, completedLessons: 4, pendingLessons: 6, certificateStatus: 'in-progress', rewardStatus: 'unlocked-pending-pok' },
    { userId: 'mock-user-001', courseId: 'academy-course-003', progress: 100, completedLessons: 8, pendingLessons: 0, certificateStatus: 'issued', rewardStatus: 'locked-claimable' },
    { userId: 'mock-user-001', courseId: 'academy-course-005', progress: 64, completedLessons: 5, pendingLessons: 4, certificateStatus: 'pending-validation', rewardStatus: 'locked-pending-acs-review' },
    { userId: 'mock-user-001', courseId: 'academy-course-006', progress: 0, completedLessons: 0, pendingLessons: 11, certificateStatus: 'restricted', rewardStatus: 'unlocked-blocked-restricted-tutor' },
  ],
  certificates: [
    {
      id: 'cert-constitutional-literacy',
      courseId: 'academy-course-001',
      studentId: 'mock-user-001',
      issueDate: '2026-05-13',
      expiration: '2027-05-13',
      verificationStatus: 'mock-verified',
      governanceValidated: true,
      daoRecognized: true,
      nftCompatible: true,
      proofHash: 'mock-pok-0x7c9f',
      publicVerificationPath: '/academy/certifications/cert-constitutional-literacy',
      certificationLevel: 'Foundational',
      issuer: 'Axodus Governance Faculty',
      governanceEligibility: 'introductory governance participation',
      daoVerificationStatus: 'root-dao-recognized',
      credentialStatus: 'active',
      operationalPermissions: ['academy onboarding completed', 'governance literacy recognized', 'voting utility eligible'],
      eligibilityImpact: 'Unlocks introductory governance participation and internal Locked $NEURONS utility.',
    },
    {
      id: 'cert-marketplace-activation',
      courseId: 'academy-course-003',
      studentId: 'mock-user-001',
      issueDate: '2026-05-15',
      expiration: '2027-05-15',
      verificationStatus: 'mock-verified',
      governanceValidated: true,
      daoRecognized: true,
      nftCompatible: true,
      proofHash: 'mock-pok-0x42aa',
      publicVerificationPath: '/academy/certifications/cert-marketplace-activation',
      certificationLevel: 'Ecosystem',
      issuer: 'Marketplace Ops Guild',
      governanceEligibility: 'marketplace utility and creator onboarding',
      daoVerificationStatus: 'partner-dao-recognized',
      credentialStatus: 'active',
      operationalPermissions: ['marketplace voucher utility', 'creator onboarding recognized', 'tutor monetization literacy'],
      eligibilityImpact: 'Supports Marketplace eligibility and internal education-commerce activation.',
    },
    {
      id: 'cert-acs-integrity-readiness',
      courseId: 'academy-course-005',
      studentId: 'mock-user-001',
      issueDate: 'pending-validation',
      expiration: 'pending-validation',
      verificationStatus: 'pending-validation',
      governanceValidated: false,
      daoRecognized: false,
      nftCompatible: true,
      proofHash: 'mock-pok-pending-acs',
      publicVerificationPath: '/academy/certifications/cert-acs-integrity-readiness',
      certificationLevel: 'Integrity',
      issuer: 'ACS Integrity Desk',
      governanceEligibility: 'ACS reviewer preview only',
      daoVerificationStatus: 'acs-review-pending',
      credentialStatus: 'pending-validation',
      operationalPermissions: ['ACS readiness preview', 'reward abuse review literacy', 'moderation queue observation'],
      eligibilityImpact: 'Prepares ACS eligibility but does not grant live moderation permissions in this MVP.',
    },
  ],
  rewards: [
    { id: 'reward-001', studentId: 'mock-user-001', courseId: 'academy-course-001', rewardType: 'Locked $NEURONS', rewardSource: 'Free Course', amount: 320, locked: true, unlockConditions: ['internal utility only', 'PoK completion', 'governance policy active'], claimable: true, governanceControlled: true, treasurySource: 'TreasuryEmissionBudget onboarding envelope', vestingSchedule: 'non-withdrawable internal balance', transferabilityStatus: 'No withdrawal, no transfer, no swap', utility: ['vouchers', 'NFT access', 'marketplace purchases', 'internal services', 'voting utilities'], issuedAt: '2026-05-13' },
    { id: 'reward-002', studentId: 'mock-user-001', courseId: 'academy-course-002', rewardType: 'Unlocked $NEURONS', rewardSource: 'Paid Course', amount: 950, locked: false, unlockConditions: ['75% progress', 'PoK exam', 'treasury budget available'], claimable: false, governanceControlled: true, treasurySource: 'TreasuryEmissionBudget professional education envelope', vestingSchedule: 'progress-based future wallet distribution', transferabilityStatus: 'Future direct wallet distribution after approval', utility: ['future wallet transfer', 'advanced certification', 'professional eligibility'], issuedAt: 'pending' },
    { id: 'reward-003', studentId: 'mock-user-001', courseId: 'academy-course-003', rewardType: 'Locked $NEURONS', rewardSource: 'Free Course', amount: 410, locked: true, unlockConditions: ['course completion', 'marketplace orientation quiz'], claimable: true, governanceControlled: true, treasurySource: 'TreasuryEmissionBudget marketplace activation envelope', vestingSchedule: 'non-withdrawable internal balance', transferabilityStatus: 'Internal ecosystem utility only', utility: ['marketplace purchases', 'educational NFTs', 'licenses', 'internal benefits'], issuedAt: '2026-05-15' },
    { id: 'reward-004', studentId: 'mock-user-001', courseId: 'academy-course-005', rewardType: 'Locked $NEURONS', rewardSource: 'Free Course', amount: 520, locked: true, unlockConditions: ['ACS quiz', 'anti-abuse case review', 'governance policy active'], claimable: false, governanceControlled: true, treasurySource: 'TreasuryEmissionBudget integrity education envelope', vestingSchedule: 'non-withdrawable internal balance after ACS review', transferabilityStatus: 'Internal ecosystem utility only', utility: ['ACS queue access', 'review vouchers', 'internal services', 'voting utilities'], issuedAt: 'pending-validation' },
    { id: 'reward-005', studentId: 'mock-user-001', courseId: 'academy-course-006', rewardType: 'Unlocked $NEURONS', rewardSource: 'Paid Course', amount: 780, locked: false, unlockConditions: ['restricted tutor review', 'publisher policy exam', 'treasury budget available'], claimable: false, governanceControlled: true, treasurySource: 'TreasuryEmissionBudget partner education envelope', vestingSchedule: 'blocked until partner restriction clears', transferabilityStatus: 'Future wallet distribution blocked by governance status', utility: ['future wallet transfer', 'publisher eligibility', 'tutor monetization credential'], issuedAt: 'blocked' },
  ],
  rewardTreasury: {
    rewardPool: 'Academy Rewards Vault mock',
    emissionBudget: '47,500 $NEURONS mock allocated',
    daoSponsorship: 'Axodus Root DAO education budget',
    educationalGrants: '12 active grant envelopes',
    contributorAllocation: '18% reserved for verified learning milestones',
    treasuryBackedIncentives: 'Governance-backed issuance only; no autonomous minting in MVP.',
  },
  flowCoverage: [
    { id: 'flow-free-locked', flow: 'Free course to Locked $NEURONS', status: 'prototype-covered', route: '/academy/courses/constitutional-onboarding', evidence: 'Free Course issues internal-only Locked $NEURONS with no withdrawal, transfer, or swap.' },
    { id: 'flow-paid-unlocked', flow: 'Paid course to Unlocked $NEURONS', status: 'prototype-covered', route: '/academy/courses/treasury-risk-sustainable-emissions', evidence: 'Paid Course shows higher Unlocked $NEURONS potential with future wallet distribution blocked by approvals.' },
    { id: 'flow-lesson-quiz-reward', flow: 'Lesson progress to quiz to reward visibility', status: 'prototype-covered', route: '/academy/workspace/constitutional-onboarding', evidence: 'Learning workspace exposes current lesson, quiz checkpoint state, PoK validation rail, and reward milestone.' },
    { id: 'flow-certification-preview', flow: 'Certification preview', status: 'prototype-covered', route: '/academy/certifications', evidence: 'Certification Viewer exposes issuer, proof hash, DAO verification, governance eligibility, and public verification path.' },
    { id: 'flow-progress-engine', flow: 'Progress Engine update preview', status: 'prototype-covered', route: '/academy/progress', evidence: 'Progress Engine exposes trust, PoK readiness, next unlocks, competency hierarchy, and Learn-to-Win signals.' },
    { id: 'flow-governance-eligibility', flow: 'Governance eligibility', status: 'prototype-covered', route: '/academy/eligibility', evidence: 'Eligibility matrix exposes DAO, proposal, validator, committee, marketplace, and federation states.' },
    { id: 'flow-acs-readiness', flow: 'ACS readiness preview', status: 'prototype-covered', route: '/academy/courses/acs-moderation-reward-abuse-review', evidence: 'ACS course, pending certificate, moderation checkpoint, and locked reward milestone model reviewer readiness.' },
  ],
  learningExecution: [
    { id: 'exec-001', courseId: 'academy-course-001', checkpoint: 'Constitutional literacy checkpoint', status: 'ready-for-review', evidence: 'lesson completion plus governance quiz', reviewer: 'Axodus Governance Faculty', proofReference: 'mock-pok-0x7c9f' },
    { id: 'exec-002', courseId: 'academy-course-002', checkpoint: 'Treasury emissions checkpoint', status: 'pending-progress', evidence: 'risk workshop and PoK exam', reviewer: 'Treasury Risk Guild', proofReference: 'mock-pok-pending-treasury' },
    { id: 'exec-003', courseId: 'academy-course-003', checkpoint: 'Marketplace utility checkpoint', status: 'verified', evidence: 'voucher exercise and marketplace quiz', reviewer: 'Marketplace Ops Guild', proofReference: 'mock-pok-0x42aa' },
    { id: 'exec-004', courseId: 'academy-course-004', checkpoint: 'Certification integrity checkpoint', status: 'locked', evidence: 'anti-fraud quiz and ACS review packet', reviewer: 'ACS Certification Queue', proofReference: 'mock-pok-pending-certification' },
    { id: 'exec-005', courseId: 'academy-course-005', checkpoint: 'ACS moderation readiness checkpoint', status: 'pending-validation', evidence: 'case review plus abuse signal quiz', reviewer: 'ACS Integrity Desk', proofReference: 'mock-pok-pending-acs' },
    { id: 'exec-006', courseId: 'academy-course-006', checkpoint: 'Partner monetization restriction checkpoint', status: 'restricted', evidence: 'royalty policy exam and tutor standing review', reviewer: 'Academy Governance Review', proofReference: 'mock-pok-restricted-partner' },
  ],
  milestoneUnlocks: [
    { id: 'milestone-001', courseId: 'academy-course-001', label: 'Locked $NEURONS internal utility', status: 'claimable-mock', rewardClass: 'Locked $NEURONS', dependency: 'Complete onboarding PoK checkpoint' },
    { id: 'milestone-002', courseId: 'academy-course-002', label: 'Unlocked $NEURONS professional reward', status: 'pending-progress', rewardClass: 'Unlocked $NEURONS', dependency: 'Reach 75% progress and pass treasury PoK exam' },
    { id: 'milestone-003', courseId: 'academy-course-003', label: 'Marketplace voucher eligibility', status: 'verified', rewardClass: 'Locked $NEURONS', dependency: 'Complete marketplace activation quiz' },
    { id: 'milestone-004', courseId: 'academy-course-004', label: 'Certification authority eligibility', status: 'locked', rewardClass: 'Unlocked $NEURONS', dependency: 'ACS anti-fraud review and advanced PoK proof' },
    { id: 'milestone-005', courseId: 'academy-course-005', label: 'ACS queue observation eligibility', status: 'pending-validation', rewardClass: 'Locked $NEURONS', dependency: 'Complete ACS case review and pass moderation PoK' },
    { id: 'milestone-006', courseId: 'academy-course-006', label: 'Publisher royalty eligibility', status: 'restricted', rewardClass: 'Unlocked $NEURONS', dependency: 'Partner tutor restriction must clear governance review' },
  ],
  progressEngine: {
    nextUnlocks: [
      { id: 'unlock-1', label: 'Treasury Risk checkpoint', reward: '240 Unlocked $NEURONS', requirement: 'Reach 75% progress and pass PoK review' },
      { id: 'unlock-2', label: 'ACS reviewer eligibility', reward: 'ACS review queue access', requirement: 'Trust score 80 and one advanced certification' },
      { id: 'unlock-3', label: 'Marketplace license voucher', reward: '180 Locked $NEURONS utility', requirement: 'Complete Marketplace Activation path' },
    ],
    analytics: [
      { label: 'PoK readiness', value: 72 },
      { label: 'Governance literacy', value: 84 },
      { label: 'Reward integrity', value: 91 },
      { label: 'Marketplace activation', value: 68 },
    ],
  },
  governanceReviews: [
    { id: 'review-constitution', area: 'Constitutional review', status: 'approved', reviewer: 'Axodus Governance Faculty', risk: 'low', scope: 'educational standards', dependency: 'Academy constitution rubric', contractReference: 'RewardPolicy', notes: 'Educational standards align with constitutional onboarding.' },
    { id: 'review-treasury', area: 'Treasury review', status: 'under-review', reviewer: 'Treasury Council', risk: 'medium', scope: 'emission budget', dependency: 'TreasuryEmissionBudget approval envelope', contractReference: 'TreasuryEmissionBudget', notes: 'Unlocked $NEURONS budget requires emission envelope confirmation.' },
    { id: 'review-reward', area: 'Reward review', status: 'approved', reviewer: 'RewardPolicy mock', risk: 'low', scope: 'locked reward policy', dependency: 'LockedNeuronsVault internal utility model', contractReference: 'LockedNeuronsVault', notes: 'Free courses issue only Locked $NEURONS with internal utility.' },
    { id: 'review-certification', area: 'Certification review', status: 'under-review', reviewer: 'ACS Certification Queue', risk: 'medium', scope: 'PoK credential legitimacy', dependency: 'PoKMinter future credential adapter', contractReference: 'PoKMinter', notes: 'Advanced PoK certificates require anti-fraud scoring.' },
  ],
  governanceReviewQueue: [
    { id: 'queue-001', item: 'Treasury Risk and Sustainable Emissions', type: 'course', priority: 'high', status: 'treasury-review', blocker: 'emission envelope confirmation' },
    { id: 'queue-002', item: 'Proof of Knowledge Certification Design', type: 'certification program', priority: 'medium', status: 'acs-review', blocker: 'anti-fraud scoring rubric' },
    { id: 'queue-003', item: 'Treasury Risk Guild', type: 'tutor entity', priority: 'medium', status: 'probation-review', blocker: 'DAO tutor moderation standing' },
  ],
  acsWorkflows: [
    { id: 'acs-tutor-review', name: 'Tutor Review', status: 'active-mock', escalation: 'manual governance review' },
    { id: 'acs-course-validation', name: 'Course Validation', status: 'active-mock', escalation: 'constitutional standards queue' },
    { id: 'acs-reward-audit', name: 'Reward Audit', status: 'active-mock', escalation: 'treasury emission budget review' },
    { id: 'acs-certification-escalation', name: 'Certification Escalation', status: 'queued-mock', escalation: 'PoK integrity panel' },
    { id: 'acs-curriculum-compliance', name: 'Curriculum Compliance', status: 'active-mock', escalation: 'Academy Governance Review' },
    { id: 'acs-pok-review', name: 'Proof of Knowledge Review', status: 'active-mock', escalation: 'ACS reviewer assignment' },
  ],
  learningPaths: [
    { id: 'path-governance-operator', title: 'Governance Operator Path', description: 'A capability path from constitutional literacy to treasury-aware governance participation.', courseIds: ['academy-course-001', 'academy-course-002', 'academy-course-004'], standing: 'approved', progress: 49, issuer: 'Axodus Root DAO', governanceCompatibility: 'proposal-readiness track', federationStatus: 'root-dao-compatible' },
    { id: 'path-marketplace-creator', title: 'Marketplace Creator Path', description: 'A formation path for tutors and creators using Locked $NEURONS utility inside Axodus Marketplace.', courseIds: ['academy-course-001', 'academy-course-003'], standing: 'approved', progress: 91, issuer: 'Marketplace Ops Guild', governanceCompatibility: 'marketplace voucher utility', federationStatus: 'partner-dao-compatible' },
  ],
  learnToWin: {
    doctrine: 'Milestone-based competency progression without casino-like reward framing.',
    achievementHierarchy: [
      { id: 'ach-001', name: 'Constitutional Literacy', status: 'earned', competency: 'governance fundamentals', rewardClass: 'Locked $NEURONS', governanceReadiness: 'introductory voting utility' },
      { id: 'ach-002', name: 'Marketplace Activation', status: 'earned', competency: 'voucher and license utility', rewardClass: 'Locked $NEURONS', governanceReadiness: 'ecosystem commerce readiness' },
      { id: 'ach-003', name: 'Treasury Emissions Operator', status: 'in-progress', competency: 'emission budget reasoning', rewardClass: 'Unlocked $NEURONS', governanceReadiness: 'treasury review required' },
      { id: 'ach-004', name: 'PoK Certification Steward', status: 'locked', competency: 'credential integrity', rewardClass: 'Unlocked $NEURONS', governanceReadiness: 'ACS reviewer threshold' },
    ],
    competencySignals: [
      { label: 'Completion integrity', value: 88 },
      { label: 'Review consistency', value: 76 },
      { label: 'Reward discipline', value: 91 },
      { label: 'DAO compatibility', value: 82 },
    ],
  },
  uiStates: {
    noCourses: 'No Academy courses match the active filters. Clear filters or broaden discovery from the contextual sidebar.',
    noRewards: 'No reward records are available for this learner in the current mock cohort.',
    noCertifications: 'No certifications have been issued for this learner yet.',
    unavailableCourse: 'This course is unavailable in the Academy mock registry or blocked by governance standing.',
    mockLoading: 'Mock loading state: Academy read models are being prepared. No network or contract request is executed.',
    mockError: 'Mock error state: Academy read model failed validation. Retry after checking mock data integrity.',
  },
};
